export const TIPO_USUARIO = {
    CLIENTE : 1,
	AUDITOR : 2,
	PROVEEDOR : 3,
	INTERNO : 4,
	PACIENTE : 5,
}